import React, { useState, useEffect, useRef } from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Contactform } from "./components/Contactform";
import axios from "axios";
import BannerDesktop from "./images/BannerBooknow.jpeg";

import BannerMobile from "./images/Banner01m.jpg";

export const Book = ({ match }) => {
  const [categories, setCategories] = useState([]);
  const [plans, setPlans] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");
  const [allDataFetched, setAllDataFetched] = useState(false);
  const [planselector, setplanselector] = useState([]);

  // =========================================================
  // CAROUSEL
  // =========================================================

  // =========================================================
  // PLAN / CATEGORY
  // =========================================================

  useEffect(() => {
    axios
      .get(window.weburl + `api/get_decrypt.php?pid=${planID}`)
      .then((response) => setplanselector(response.data.cat_id))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responsedt = await axios.get(
          window.weburl + `api/get_decrypt.php?pid=${planID}`,
        );

        const curCatName = responsedt.data.cat_id;
        const curPlanName = responsedt.data.plan_id;

        const response = await axios.get(
          window.weburl + "api/get_categories.php",
        );

        setCategories(response.data);
        setSelectedCategory(curCatName);
        getPlans(curCatName);
        setSelectedPlan(curPlanName);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  function getPlans(category) {
    axios
      .get(window.weburl + `api/get_plans.php?cid=${category}`)
      .then((response) => setPlans(response.data))
      .catch((error) => console.log(error));
  }

  // =========================================================
  // HTML DECODE
  // =========================================================

  var decodeHTML = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  function createMarkup(content) {
    return { __html: decodeHTML(content) };
  }

  const planID = match.params.slug;

  // =========================================================
  // PLAN HEADER
  // =========================================================

  const [planHeader, setplanHeader] = useState([]);

  useEffect(() => {
    axios
      .get(window.weburl + `api/get_current_plan.php?pid=${planID}`)
      .then((response) =>
        setplanHeader(
          (response.data[0].catID ? response.data[0].category + " " : "") +
            (response.data[0].pname ? response.data[0].pname + " " : "") +
            (response.data[0].price
              ? "<i class='finr'></i>" + response.data[0].price
              : "") +
            (response.data[0].ptitle ? " With " + response.data[0].ptitle : ""),
        ),
      )
      .catch((error) => console.log(error));
  }, []);

  // =========================================================
  // STATE / CITY
  // =========================================================

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  // Searchable city dropdown
  const [citySearch, setCitySearch] = useState("");
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);

  // City dropdown reference
  const cityDropdownRef = useRef(null);

  // Get states
  useEffect(() => {
    axios
      .get(window.weburl + "api/get_states.php")
      .then((response) => setStates(response.data))
      .catch((error) => console.log(error));
  }, []);

  // Get cities
  function getCities(state) {
    axios
      .get(window.weburl + `api/get_cities.php?sid=${state}`)
      .then((response) => {
        setCities(response.data);

        // Reset selected city when state changes
        setSelectedCity("");
        setCitySearch("");
        setCityDropdownOpen(false);
      })
      .catch((error) => console.log(error));
  }

  // Filter cities based on search
  const filteredCities = cities.filter((city) =>
    String(city.cityname || "")
      .toLowerCase()
      .includes(citySearch.toLowerCase()),
  );

  // Close city dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        cityDropdownRef.current &&
        !cityDropdownRef.current.contains(event.target)
      ) {
        setCityDropdownOpen(false);
        setCitySearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // =========================================================
  // INSERT QUERY START
  // =========================================================

  const [user_name, setusername] = useState();
  const [user_mobile, setusermobile] = useState();

  // Focus
  const ref_category = useRef(null);
  const ref_plan = useRef(null);
  const ref_name = useRef(null);
  const ref_mobile = useRef(null);
  const ref_state = useRef(null);
  const ref_city = useRef(null);

  const [isDisabled, setIsDisabled] = useState(true);

  const handledisable = () => {
    if (isValidPhone(user_mobile) && user_mobile) {
      const element = document.getElementById("submit_button_text");

      element.classList.remove("disabled");
      setIsDisabled(false);
    } else {
      const element = document.getElementById("submit_button_text");

      element.classList.add("disabled");
      setIsDisabled(true);
    }
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  function isValidPhone(phone) {
    const regex = /^[6-9]\d{9}$/gi;
    return regex.test(phone);
  }

  // =========================================================
  // SUBMIT
  // =========================================================

  const handleSubmit = () => {
    if (!selectedCategory) {
      alert("Please select Category");
      ref_category.current.focus();
      return false;
    } else if (!selectedPlan) {
      alert("Please select plan");
      ref_plan.current.focus();
      return false;
    } else if (!isValidPhone(user_mobile)) {
      alert("Please enter Mobile number");
      ref_mobile.current.focus();
      return false;
    } else if (!selectedState) {
      alert("Please select State");
      ref_state.current.focus();
      return false;
    } else if (!selectedCity) {
      alert("Please select City");
      ref_city.current.focus();
      return false;
    } else {
      document.getElementById("submit_button_text").innerText = "SUBMITTING...";

      const url = window.weburl + "/api/insert_hook.php";

      let fData = new FormData();

      fData.append("catID", selectedCategory ? selectedCategory : "");

      fData.append("planID", selectedPlan ? selectedPlan : "");

      fData.append("user_name", user_name);
      fData.append("user_mobile", user_mobile);

      fData.append("user_state", selectedState ? selectedState : "");

      fData.append("user_city", selectedCity ? selectedCity : "");

      fData.append("td_name", "bookings");
      fData.append("utm_url", window.location.href);

      axios
        .post(url, fData)
        .then((response) => {
          // Google Ads conversion
          if (window.gtag) {
            window.gtag("event", "conversion", {
              // send_to: "AW-801924308/pEhpCICE9_4CENTJsf4C",
              send_to: "AW-801924308/HeMjCImtpfIbENTJsf4C",
            });
          }

          // Meta Pixel
          if (window.fbq) {
            window.fbq("track", "Lead");
          }

          if (selectedCategory == "15") {
            alert(
              'Thank you for your booking enquiry. It has been successfully submitted. After clicking "OK", you will be redirected to our portal to set up your account. Your subscription will be ready in seconds. An expert will be in touch with you shortly.',
            );

            const userData = window.btoa(
              JSON.stringify({
                name: user_name,
                mobile: user_mobile,
                city: selectedCity,
                state: selectedState,
                planId: selectedPlan,
              }),
            );

            setTimeout(() => {
              window.location.href = `https://subscribe.coveidentity.com/netplus/?plan_id=${selectedPlan}&data=${userData}`;
            }, 1500);
          } else {
            sessionStorage.setItem(
              "thankYouReturnUrl",
              "/book-now/bVhQYTVDZ1hCN3JkWnppc0g2N2lidz09",
            );

            window.location.href = "/thank-you";
          }
        })
        .catch((error) => alert(error));

      console.log(true);

      document.getElementById("submit_button_text").innerText = "SUBMIT";

      document.getElementById("selectedCategory").value = "";
      document.getElementById("selectedPlan").value = "";
      document.getElementById("user_name").value = "";
      document.getElementById("user_mobile").value = "";
      document.getElementById("selectedState").value = "";
      document.getElementById("selectedCity").value = "";
    }
  };

  // =========================================================
  // RETURN
  // =========================================================

  return (
    <>
      <Header />

      <section id="banner" className="p-0">
        <div className="banner booknow filter m-0 h-120"></div>
      </section>

      <section id="login" className="p-0">
        <div className="booknow filter m-0">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div className="title m-0">
                  <span>Book Now</span>
                </div>

                <div className="heading">
                  <h4
                    dangerouslySetInnerHTML={createMarkup(
                      "Book your Netplus " + planHeader,
                    )}
                  ></h4>
                </div>

                {/* =================================
                    CAROUSEL + FORM
                ================================== */}

                <div className="booknow-layout">
                  {/* CAROUSEL */}
                  <div className="booknow-video booknow-carousel">
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        srcSet={BannerMobile}
                      />
                      <img
                        src={BannerDesktop}
                        alt="Book now"
                        className="carousel-slide active"
                      />
                    </picture>
                  </div>
                  {/* FORM */}
                  <div className="footerform bookingform">
                    <div className="form">
                      <ul>
                        {/* CATEGORY */}
                        <li>
                          <select
                            name="selectedCategory"
                            id="selectedCategory"
                            value={selectedCategory}
                            onChange={(event) => {
                              setSelectedCategory(event.target.value);

                              getPlans(event.target.value);
                            }}
                            ref={ref_category}
                          >
                            <option value="">Select Category</option>

                            {categories.map((category) => (
                              <option key={category.sno} value={category.sno}>
                                {category.category}
                              </option>
                            ))}
                          </select>
                        </li>

                        {/* PLAN */}
                        <li>
                          <select
                            name="selectedPlan"
                            id="selectedPlan"
                            value={selectedPlan}
                            onChange={(event) =>
                              setSelectedPlan(event.target.value)
                            }
                            ref={ref_plan}
                          >
                            <option value="">Select Plan</option>

                            {plans.map((plan) => (
                              <option
                                key={plan.sno}
                                value={plan.sno}
                                dangerouslySetInnerHTML={createMarkup(
                                  plan.pname +
                                    " " +
                                    plan.ptitle +
                                    " " +
                                    plan.ptype,
                                )}
                              ></option>
                            ))}
                          </select>
                        </li>

                        {/* NAME */}
                        <li>
                          <input
                            type="text"
                            name="user_name"
                            id="user_name"
                            placeholder="Your name"
                            pattern="[a-zA-Z\s]+"
                            value={user_name}
                            onChange={(e) => {
                              setusername(e.target.value);
                            }}
                            onKeyUp={handledisable}
                            ref={ref_name}
                          />
                        </li>

                        {/* MOBILE */}
                        <li>
                          <input
                            type="text"
                            name="user_mobile"
                            id="user_mobile"
                            placeholder="Mobile number*"
                            value={user_mobile}
                            onChange={(e) => {
                              setusermobile(e.target.value);
                            }}
                            onKeyUp={handledisable}
                            ref={ref_mobile}
                          />
                        </li>

                        {/* STATE */}
                        <li>
                          <select
                            name="selectedState"
                            id="selectedState"
                            value={selectedState}
                            onChange={(event) => {
                              setSelectedState(event.target.value);

                              getCities(event.target.value);
                            }}
                            ref={ref_state}
                          >
                            <option value="">Select State*</option>

                            {states.map((state) => (
                              <option key={state.stateid} value={state.stateid}>
                                {state.sname}
                              </option>
                            ))}
                          </select>
                        </li>

                        {/* =================================
                            SEARCHABLE CITY
                        ================================== */}

                        <li>
                          <div className="city-dropdown" ref={cityDropdownRef}>
                            {/* CITY FIELD */}
                            <input
                              type="text"
                              name="selectedCity"
                              id="selectedCity"
                              value={
                                cityDropdownOpen
                                  ? citySearch
                                  : cities.find(
                                      (city) => city.cityid == selectedCity,
                                    )?.cityname || ""
                              }
                              placeholder="Select City*"
                              autoComplete="off"
                              disabled={!selectedState}
                              readOnly={!cityDropdownOpen}
                              ref={ref_city}
                              onFocus={() => {
                                if (!selectedState) return;

                                setCityDropdownOpen(true);
                                setCitySearch("");
                              }}
                              onClick={() => {
                                if (!selectedState) return;

                                setCityDropdownOpen(true);
                                setCitySearch("");
                              }}
                              onChange={(e) => {
                                setCitySearch(e.target.value);

                                setCityDropdownOpen(true);
                              }}
                            />

                            {/* ARROW */}
                            <span
                              className={`city-dropdown-arrow ${
                                cityDropdownOpen ? "open" : ""
                              }`}
                              onClick={() => {
                                if (!selectedState) return;

                                setCityDropdownOpen((prev) => !prev);

                                if (!cityDropdownOpen) {
                                  setCitySearch("");
                                }
                              }}
                            >
                              ˅
                            </span>

                            {/* CITY DROPDOWN */}
                            {cityDropdownOpen && selectedState && (
                              <div className="city-options">
                                {/* SEARCH */}
                                <div className="city-search-box">
                                  <input
                                    type="text"
                                    placeholder="Search city..."
                                    value={citySearch}
                                    onChange={(e) =>
                                      setCitySearch(e.target.value)
                                    }
                                    autoFocus
                                  />
                                </div>

                                {/* CITY LIST */}
                                <div className="city-list">
                                  {filteredCities.length > 0 ? (
                                    filteredCities.map((city) => (
                                      <div
                                        key={city.cityid}
                                        className="city-option"
                                        onClick={() => {
                                          setSelectedCity(city.cityid);

                                          setCitySearch("");

                                          setCityDropdownOpen(false);
                                        }}
                                      >
                                        {city.cityname}
                                      </div>
                                    ))
                                  ) : (
                                    <div className="no-city">No city found</div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </li>

                        {/* SUBMIT */}
                        <li className="buttnprop">
                          <input
                            type="submit"
                            value=""
                            id="submit_button"
                            disabled={isDisabled}
                            onClick={handleSubmit}
                          />

                          <span id="submit_button_text" className="disabled">
                            Submit
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Contactform /> */}

      <Footer />
    </>
  );
};
